import React from "react";
import {
    DialogOverlay,
    DialogBox,
    DialogHeader,
    DialogBody,
    DialogFooter,
    DialogCloseBtn,
    DialogBtn,
    InfoField,
    InfoText,
} from "./ANCScheduleStyles";

function formatDate(dateStr) {
    if (!dateStr) return "—";
    try {
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
    } catch (e) {
        return dateStr;
    }
}

/**
 * ANCRescheduleDialog — Modal dialog for rescheduling a single ANC contact
 *
 * Props:
 *  - open: boolean
 *  - item: the schedule item being rescheduled
 *  - rescheduleDate: current selected date string
 *  - onDateChange: function(dateStr)
 *  - onConfirm: function()
 *  - onClose: function()
 *  - saving: boolean
 */
const ANCRescheduleDialog = function(props) {
    const open = props.open;
    const item = props.item;
    const rescheduleDate = props.rescheduleDate;
    const onDateChange = props.onDateChange;
    const onConfirm = props.onConfirm;
    const onClose = props.onClose;
    const saving = props.saving;

    if (!open || !item) return null;

    const today = new Date().toISOString().slice(0, 10);

    return (
        <DialogOverlay onClick={function(e) { if (e.target === e.currentTarget) onClose(); }}>
            <DialogBox>
                <DialogHeader>
                    <h4>📅 Reschedule Contact {item.contact_number}</h4>
                    <DialogCloseBtn onClick={onClose}>✕</DialogCloseBtn>
                </DialogHeader>

                <DialogBody>
                    {/* Current Info */}
                    <InfoField>
                        <label>Contact</label>
                        <InfoText>
                            Contact {item.contact_number}
                            {item.scheduled_gestational_age_weeks
                                ? " — " + item.scheduled_gestational_age_weeks + " weeks gestation"
                                : ""}
                        </InfoText>
                    </InfoField>

                    <InfoField>
                        <label>Currently Scheduled</label>
                        <InfoText>
                            {formatDate(item.scheduled_date)}
                        </InfoText>
                    </InfoField>

                    {/* New Date Picker */}
                    <InfoField>
                        <label>New Date</label>
                        <input
                            type="date"
                            value={rescheduleDate || ""}
                            min={today}
                            onChange={function(e) { onDateChange(e.target.value); }}
                        />
                    </InfoField>

                    {/* Date difference hint */}
                    {rescheduleDate && item.scheduled_date && rescheduleDate !== item.scheduled_date && (
                        <div style={{
                            padding: "8px 14px",
                            background: "#e3f2fd",
                            borderRadius: "6px",
                            fontSize: "0.82rem",
                            color: "#1565c0",
                            marginTop: "-8px",
                        }}>
                            {(function() {
                                const orig = new Date(item.scheduled_date);
                                const newD = new Date(rescheduleDate);
                                const diff = Math.round((newD - orig) / (24 * 60 * 60 * 1000));
                                if (diff > 0) return "ℹ Moving " + diff + " day" + (diff !== 1 ? "s" : "") + " later than originally scheduled";
                                if (diff < 0) return "ℹ Moving " + Math.abs(diff) + " day" + (Math.abs(diff) !== 1 ? "s" : "") + " earlier than originally scheduled";
                                return "Same as current date";
                            })()}
                        </div>
                    )}
                </DialogBody>

                <DialogFooter>
                    <DialogBtn onClick={onClose}>Cancel</DialogBtn>
                    <DialogBtn
                        variant="primary"
                        onClick={onConfirm}
                        disabled={saving || !rescheduleDate || rescheduleDate === item.scheduled_date}
                    >
                        {saving ? "Saving..." : "Confirm Reschedule"}
                    </DialogBtn>
                </DialogFooter>
            </DialogBox>
        </DialogOverlay>
    );
};

export default ANCRescheduleDialog;
